module.exports = __webpack_public_path__ + "static/media/balance_dark.cfd40dd2.svg";